<template>
  <span>
    <!-- <div class="md-layout">
      <div class="md-layout-item ml-auto">
        <ExportJsonToCsv :dataTable="dataTable"/>
      </div>
    </div> -->
    <div class="md-layout-item md-size-100 mx-auto">
      <ProductivityTable @updateResponse='dataTable = $event'/>
    </div>
  </span>
</template>

<script>
import ProductivityTable from '@/components/ProductivityTable'
// import ExportJsonToCsv from '@/pages/ExportJsonToCsv'
export default {
  components: {
    ProductivityTable
    // ExportJsonToCsv
  },
  data () {
    return {
      dataTable: null
    }
  }
}
</script>
